import React from 'react'
import Head from 'next/head'
import {
  LANDING_HERO,
  LANDING_HERO_DESKTOP,
  LANDING_HERO_MOBILE,
} from '../../../constants/images'
import { Type } from '../common'
import { AngelFundingLogo } from '../svg'
import SEO from './SEO'

const ShutdownPage = () => {
  return (
    <>
      {process.env.NEXT_PUBLIC_ENV_NAME !== 'production' && (
        <meta name="robots" content="noindex,nofollow" />
      )}
      <Head>
        <link
          as="image"
          rel="prefetch"
          href={LANDING_HERO_MOBILE}
          media="(max-width: 639px)"
        />
        <link
          as="image"
          rel="prefetch"
          href={LANDING_HERO}
          media="(min-width: 640px) and (max-width: 1279px)"
        />
        <link
          as="image"
          rel="prefetch"
          href={LANDING_HERO_DESKTOP}
          media="(min-width: 1280px)"
        />
      </Head>

      <SEO
        title="Angel Funding"
        description="After several years of bringing light-amplifying stories to the big screen and television, we are announcing the end of Angel Funding"
        image="https://images.angelstudios.com/image/upload/v1699022164/angel-funding/angel_funding_meta.jpg"
        fullPath="/"
      />

      <main className="h-full min-h-screen bg-core-gray-100 flex items-center justify-center">
        <div className="fixed inset-0 sm:relative max-w-xl sm:rounded-xl bg-hero-mobile bg-cover bg-center overflow-hidden">
          <div className="absolute inset-0 sm:relative flex flex-col justify-center backdrop-blur-sm p-6 md:p-16">
            <div className="flex justify-center mb-4 sm:mb-6">
              <AngelFundingLogo
                className="h-[32px]"
                fill1="#fff"
                fill2="#fff"
              />
            </div>

            <Type
              as="p"
              variant={['paragraph-sm', 'sm:paragraph-lg']}
              className=" text-core-white leading-relaxed sm:leading-normal"
            >
              After several years of helping facilitate investment in film and
              television projects, we’re announcing the closure of Angel
              Funding. Angel Funding operated as a platform that enabled
              investors to participate in offerings under Regulation CF and
              Regulation A. While this platform is now discontinued, Angel
              Studios and Angel.com continue to operate independently and are
              not affected by this change. Our film and television library
              continues to grow, with new stories and releases being added
              regularly. If you have questions regarding a security purchased
              through Angel Funding, please contact{' '}
              <a href="mailto:support@angel.com" className="underline">
                support@angel.com
              </a>
              . Our team will connect you with the appropriate issuer for
              further information.
            </Type>

            <Type
              as="p"
              variant={['paragraph-sm', 'sm:paragraph-lg']}
              className="text-core-white mt-4"
            >
              See you at the movies,
              <br />
              <span className="italic">The Angel Funding Team</span>
            </Type>
          </div>
        </div>
      </main>
    </>
  )
}

export default ShutdownPage
